import { Box, Button, Layer, Text } from 'grommet';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { UsageTypeSelect } from '../..';
import { Commercial, TCommercialId, UsageType } from '@talon/web/lib/api';

export interface ICreateUsageModalProps {
  commercial: Commercial;
  addUsage: (commercialId: TCommercialId, usageType: UsageType) => void;
  setShowModal: (isVisible: boolean) => void;
}

export const CreateUsageModal = observer(({ commercial, addUsage, setShowModal }: ICreateUsageModalProps) => {
  const [type, setType] = useState<UsageType>();

  return (
    <Layer
      onEsc={() => setShowModal(false)}
      onClickOutside={() => setShowModal(false)}
      position="center"
      modal={true}
      margin="large"
    >
      <Box
        direction="column"
        align="start"
        pad="small"
        justify="around"
        width="medium"
        height="medium"
        background="light-1"
        round="small"
      >
        <Box gap="small" pad="small" justify="center" fill="horizontal">
          <Box fill="horizontal">
            <Text>Usage Type:</Text>
          </Box>
          <Box fill="horizontal">
            <UsageTypeSelect commercialType={commercial.type} val={type} onChange={(val) => setType(val)} />
          </Box>
        </Box>

        <Button
          pad="small"
          margin="small"
          hoverIndicator
          onClick={() => (type ? addUsage(commercial.id, type) : {})}
          disabled={!type}
          label="Add Usage"
        />
      </Box>
    </Layer>
  );
});
